import styled from "styled-components";

export const ContainerMessageFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
`;

export const MessageFilterButton = styled.button`
  border: 1px solid
    ${(props) => (props.active ? `var(--primary-color)` : "var(--dark-color)")};
  color: ${(props) => (props.active ? `var(--primary-color)` : "var(--dark-color)")};
  background: white;
  padding: 3px 15px;
  margin: 15px 7px;
  border-radius: var(--border-radius-2);
  font-size: var(--font-size-sm);
  @media screen and (max-width: 576px) {
    margin: 7px;
  }
`;
